export interface IModalAdultProps {
  analyticsSender?: (name: string, params?: Record<string, unknown>) => void;
  analyticsPayload?: Record<string, unknown>;
  approveLabel?: string;
  rejectLabel?: string;
}

export type IModalAdultEmits = {
  approve: [];
  reject: [];
};

export enum showAdultCookie {
  Yes = "Y",
  No = "N",
}
